const FREQUENCY_LABELS = {
    single: 'One-Time Clean',
    weekly: 'Weekly Clean',
    biweekly: 'Clean Every 2 Weeks',
    monthly: 'Clean Every 4 Weeks',
};

const PACKAGE_INFO = {
    1: { name: 'Design with Time', frequency: 'single' },
    9: { name: 'Deep Clean', frequency: 'single' },
    17: { name: 'Move In/Move Out', frequency: 'single' },
    6: { name: 'Premium Weekly', frequency: 'weekly' },
    10: { name: 'Alternating Weekly', frequency: 'weekly' },
    2: { name: 'Alternating Biweekly', frequency: 'biweekly' },
    5: { name: 'Premium Biweekly', frequency: 'biweekly' },
    4: { name: 'Premium Monthly', frequency: 'monthly' },
};

export function mapFrequency(frequency) {
    return FREQUENCY_LABELS[frequency] ?? null;
}

export function getPackageInfo(packageId) {
    return PACKAGE_INFO[packageId] ?? { name: null, frequency: null };
}

function pushToDataLayer(payload) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}

export function toE164(phoneRaw) {
    if (!phoneRaw) return null;
    const digitsOnly = phoneRaw.replace(/\D/g, '');
    if (digitsOnly.length === 10) {
        return `+1${digitsOnly}`;
    }
    if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
        return `+${digitsOnly}`;
    }
    return null;
}

async function sha256Hex(value) {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

export async function hashEmail(email) {
    if (!email) return null;
    const normalized = email.trim().toLowerCase();
    const [localPart, domain] = normalized.split('@');
    if (!domain) return null;
    return sha256Hex(`${localPart.replace(/\./g, '')}@${domain}`);
}

export async function hashPhone(phoneE164) {
    if (!phoneE164) return null;
    return sha256Hex(phoneE164.trim());
}

export function trackZipQuery(zipCode, servicable) {
    pushToDataLayer({
        event: 'user_zip_query',
        user_zip_code: zipCode,
        servicable,
    });
}

export async function trackContactInformation(phone, email) {
    const [user_phone, user_email] = await Promise.all([
        hashPhone(toE164(phone)),
        hashEmail(email),
    ]);
    pushToDataLayer({
        event: 'ext_contact_information',
        user_phone,
        user_email,
    });
}

export function trackPackageSelection({ packageId, packagePrice }) {
    const { name: packageName, frequency } = getPackageInfo(packageId);
    pushToDataLayer({
        event: 'ext_package_selection',
        frequency: mapFrequency(frequency),
        package_name: packageName,
        package_price: packagePrice,
    });
}

export function trackScheduleCleaning() {
    pushToDataLayer({ event: 'ext_schedule_cleaning' });
}

export function trackCleaningAddressInformation() {
    pushToDataLayer({ event: 'ext_cleaning_address_information' });
}

export async function trackScheduleNow({ phone, email, zipCode, packageId, packagePrice }) {
    const [user_phone, user_email] = await Promise.all([
        hashPhone(toE164(phone)),
        hashEmail(email),
    ]);
    const { name: packageName, frequency } = getPackageInfo(packageId);

    pushToDataLayer({
        event: 'ext_schedule_now',
        user_phone,
        user_email,
        user_zip_code: zipCode,
        frequency: mapFrequency(frequency),
        package_name: packageName,
        package_price: packagePrice,
    });
}

export function trackFranchiseSlug(franchiseeSlug) {
    pushToDataLayer({
        event: 'virtual_page_view',
        franchise_slug: franchiseeSlug || null,
        page_path: window.document.URL,
    });
}